<template>
  <div class="swiper">
    <swiper :options="swiperOption" ref="mySwiper">
			<swiper-slide v-for="(item,index) in banner" :key="item.ID">
				<img :src="`http://boyang.sansg.com/upload/${item.BIGURL}`" alt="">
        <img :src="`http://boyang.sansg.com/upload/${item.PICURL}`" alt="" class="small" v-if="index==0">
			</swiper-slide>
		</swiper>
    <div class="swiper-pagination"></div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  components: {
    swiper,
    swiperSlide
  },
  data(){
		return{
			swiperOption:{
        notNextTick: true,
        loop: true,
        autoplay: true,
        init:false,
        effect : 'fade',
        fadeEffect: {
          crossFade: true,
        },
        pagination : {
          el: '.swiper .swiper-pagination',
          clickable: true,
        }
      },
      banner:[],
      isPC: document.body.clientWidth>768
		}
  },
  created(){
    this.getdata()
  },
  watch: {
    isPC: function(){
      this.getdata()
    }
  },
  mounted(){
    window.addEventListener('resize',this.widthChange)
  },
  methods: {
    getdata(){
      let type=this.isPC?'首页banner':'首页手机banner'
      this.$$axios.get('/php/pic.php', {
        params: {
          type: type,
          num:10
        }
      })
      .then(res=>{
        this.banner=res.data
      }).then(()=>{
        this.$refs.mySwiper.swiper.init()
      })
      .catch(error=>{
        console.log(error);
      });
    },
    widthChange(){
      this.isPC=document.body.clientWidth>768
    }
  }
}
</script>

<style scoped>
.swiper{
  position: relative;
}
.swiper img{
  display: block;
  width: 100%;
}
.swiper img.small{
  position: absolute;
  /* left: 35.26%; */
  left: 0%;
  bottom: -13.06%;
  /* width: 44.42%; */
  width: 100%;
}
.swiper .swiper-pagination{
  left: 0;
  bottom: 4.75%;
  width: 35.26%;
}
</style>

<style>
.swiper .swiper-container{
  overflow: initial;
}
.swiper .swiper-pagination .swiper-pagination-bullet{
  width: 65px;
  height: 1px;
  background-color: rgba(255,255,255,.3);
  margin: 0 3px;
  opacity: 1;
}
.swiper .swiper-pagination .swiper-pagination-bullet-active{
  background-color: #fff;
}
@media(max-width: 768px){
  .swiper .swiper-pagination{
    display: none;
  }
  .swiper img:not(.small){
    height: 100vh;
    object-fit: cover;
  }
  .swiper img.small{
    display: none;
  }
}
</style>


